<div class="container-fluid auth">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-xl-10 col-lg-12 col-md-9">
                <div class="card o-hidden border-0 shadow-lg my-5">
                    <div class="card-body p-0">
                        <div class="row m-0">
                            <div class="col-lg-6 d-flex bg-image-1 flex-column align-items-center p-4">
                                    <img class="img-fluid p-5 relative" src="assets/logo.png"/>
                                    <button class="mb-2" mat-raised-button color="accent" (click)="newAppointment()" type="button">Make an Appointment</button>
                                    <button class="mb-2" mat-raised-button color="accent" (click)="docuMerge()" type="button">DocuMerge</button>
                            </div>
                            <div class="col-lg-6">
                                <router-outlet></router-outlet>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<footer class="sticky-footer bg-white">
    <div class="container my-auto">
        <div class="copyright text-center my-auto">
            <span>&copy; Destini 2023</span>
        </div>
    </div>
</footer>